<h2 mat-dialog-title>
  <mat-icon>videogame_asset</mat-icon>
  Terminalstyring for {{ paymentTerminal.serialNumber }}

  <span>
    @if (paymentTerminal.chargingStationLocationInfo) {
      {{ paymentTerminal.chargingStationLocationInfo.chargingStationLocationName }} -
      {{ paymentTerminal.chargingStationLocationInfo.chargingStationLocationFullAddress }}
    } @else {
      ingen tilknyttede lokationer
    }
  </span>
</h2>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content>
  <div class="flex-wrap">
    <div class="flex-wrap__col flex-wrap__col--60">
      <div class="margin--bottom-m">
        <strong>Send kommandoer til terminalen ved at klikke på nedstående knapper.</strong>
      </div>
      @if (!paymentTerminal.online) {
        <ok-feedback-info>
          <b>Terminal offline</b>
          <br />
          <p>{{ paymentTerminal.serialNumber }} er offline og der kan således ikke sendes kommandoer til den.</p>
        </ok-feedback-info>
      }

      <div>
        <button
          mat-raised-button
          color="primary"
          (click)="resetCustomInputFields(); sendCommand(screenUpdateCommand.Reset)"
          class="margin--right-m"
          [disabled]="loading() || !commandsEnabled">
          Nulstil / startskærmen
        </button>
        <button
          mat-raised-button
          color="primary"
          (click)="resetCustomInputFields(); sendCommand(screenUpdateCommand.Connectors)"
          class="margin--right-m"
          [disabled]="loading() || !commandsEnabled">
          Vis ladestik
        </button>
        <button
          mat-raised-button
          color="primary"
          (click)="doActivateCardReaderDropdown = !doActivateCardReaderDropdown; doCustomMessage = false"
          class="margin--right-m"
          [disabled]="loading() || !commandsEnabled">
          Aktiver kortlæser
        </button>
        <button
          mat-raised-button
          color="primary"
          (click)="resetCustomInputFields(); doQrCodeSend = true"
          class="margin--right-m"
          [disabled]="loading() || !commandsEnabled">
          Send QR kode
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="loading() || !commandsEnabled"
          mat-button
          [matMenuTriggerFor]="menu"
          mat-flat-button
          color="primary"
          class="btn-icon reverse"
          type="button">
          <span>Fejlskærme</span>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #menu="matMenu" class="payment-terminal-menu" title="Opret betalingsterminal">
          <button mat-menu-item (click)="doCustomMessage = false; sendCommand(screenUpdateCommand.Error, errorMessageType.SessionExpired)">
            Session er udløbet
          </button>
          <button
            mat-menu-item
            (click)="resetCustomInputFields(); sendCommand(screenUpdateCommand.Error, errorMessageType.CannotConnectToChargingStation)">
            Kan ikke forbinde til ladestander
          </button>
          <button
            mat-menu-item
            (click)="resetCustomInputFields(); sendCommand(screenUpdateCommand.Error, errorMessageType.SelectedConnectorNotAvailable)">
            Ladepunkt er ikke tilgængeligt
          </button>
          <button
            mat-menu-item
            (click)="resetCustomInputFields(); sendCommand(screenUpdateCommand.Error, errorMessageType.TerminalIsOutOfOrder)">
            Terminal er ude af drift
          </button>
          <button mat-menu-item (click)="doCustomMessage = !doCustomMessage; doActivateCardReaderDropdown = false">
            Send dynamisk besked
          </button>
        </mat-menu>
      </div>

      @if (doQrCodeSend) {
        <div class="margin--top-l">
          <div class="form-row" [formGroup]="qrCodeForm">
            <mat-form-field>
              <mat-label>Vælg QR kode du vil sende</mat-label>
              <mat-select formControlName="urlForQrCode" okCustomDropDownArrowDirective>
                <mat-option [value]="'https://okapp.dk/mKvi9nB8Kob'">OK-app i App Store</mat-option>
              </mat-select>
              <mat-icon matSuffix></mat-icon>
            </mat-form-field>
            <button
              mat-raised-button
              color="primary"
              (click)="sendCommand(screenUpdateCommand.SendQrCode, undefined, null, urlForQrCode.value)"
              class="margin--right-l"
              [disabled]="loading() || !urlForQrCode.value || !commandsEnabled">
              Send QR kode
            </button>
          </div>
        </div>
      }

      @if (typeAheadModel && doActivateCardReaderDropdown && !doCustomMessage) {
        <div class="margin--top-l">
          <div class="form-row" [formGroup]="amountForm">
            <mat-form-field>
              <mat-label>Angiv reservationsbeløb</mat-label>
              <div [formGroup]="typeAheadModel">
                <input type="text" #amountSelect formControlName="typeAheadQuery" [matAutocomplete]="auto" matInput placeholder="Vælg" />
              </div>
              <mat-autocomplete
                #auto="matAutocomplete"
                hideSingleSelectionIndicator="true"
                [displayWith]="displayFn"
                okCustomDropDownArrowDirective>
                @for (amount of filteredAmounts; track amount.name) {
                  <mat-option [value]="amount">{{ amount.amount }} : {{ amount.name }}</mat-option>
                }
              </mat-autocomplete>
              @if (amount.value) {
                <mat-icon matSuffix class="clear-input-field-button" (click)="resetAmount()">close</mat-icon>
              }
              <mat-icon matSuffix></mat-icon>
            </mat-form-field>
            <button
              mat-raised-button
              color="primary"
              (click)="sendCommand(screenUpdateCommand.StartCardRead)"
              class="margin--right-l"
              [disabled]="loading() || !amount.value || !commandsEnabled">
              Aktiver kortlæser med reservationsbeløbet
            </button>
          </div>
        </div>
      }
      @if (doCustomMessage && !doActivateCardReaderDropdown) {
        <div class="margin--top-l">
          @if (!loading()) {
            <form [formGroup]="customErrorFormGroup">
              <ok-feedback-info>
                Bemærk at denne type fejlbesked låser terminalens UI. Dvs. kunderne kan ikke længere bruge terminalen. Nulstilles ved at man
                blot sender en "startside" til terminalen.
              </ok-feedback-info>
              <div class="form-row">
                <mat-form-field class="margin--top-m mdc-textarea-fix">
                  <mat-label>Besked</mat-label>
                  <textarea
                    cols="10"
                    rows="8"
                    maxlength="{{ customErrorMessageMaxLength }}"
                    matInput
                    placeholder="Skriv besked til terminalen?"
                    formControlName="customErrorMessage"></textarea>

                  <mat-hint align="end" class="no-wrap">
                    {{ customErrorMessage.value?.length || 0 }}/{{ customErrorMessageMaxLength }} karakterer
                  </mat-hint>
                </mat-form-field>
              </div>
              <button
                mat-flat-button
                color="primary"
                [disabled]="customErrorFormGroup.invalid"
                (click)="sendCommand(screenUpdateCommand.Error, errorMessageType.CustomErrorMessage, customErrorMessage.value)">
                Send til terminalen
              </button>
            </form>
          }
        </div>
      }
    </div>
    <div class="flex-wrap__col flex-wrap__col--40 relative emulator">
      <adm-loading-spinner [loadingSignal]="loading()"></adm-loading-spinner>
      @if (latestUiLog(); as uiLog) {
        <adm-ui-log-card [uiLog]="uiLog" [showUpdated]="true" (terminalEmulatorEvent)="handleTerminalEmulator($event)"></adm-ui-log-card>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  @if (paymentTerminal) {
    <div class="unit-identifier">
      <span>Terminal serienummer</span>
      {{ paymentTerminal.serialNumber }}
    </div>
  }

  <button class="actions__button" type="button" mat-dialog-close mat-button (click)="close()">Luk</button>
</mat-dialog-actions>
